import ManagedErrorToasts from '@/components/error/ManagedErrorToasts';
import AdminPageLayout from '@/components/layout/AdminPageLayout';
import ApprovalDocumentsModal from '@/components/orders/modals/ApprovalDocumentsModal';
import { ConfirmDispenseModal } from '@/components/orders/modals/ConfirmDispenseModal';
import { MarkAsCollectedModal } from '@/components/orders/modals/MarkAsCollectedModal';
import SplitOrderModal from '@/components/orders/modals/SplitOrderModal';
import UnableToDispenseModal from '@/components/orders/modals/UnableToDispenseModal';
import PharmacistOrderTables from '@/components/orders/PharmacistOrderTables';
import { PharmacistOrdersProvider } from '@/context/orders/PharmacistOrders';
import { PharmacistOrdersModalsProvider } from '@/context/orders/PharmacistOrdersModals';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';
import { OrderSelectionProvider } from '@montugroup/circuit-shared/context/table/OrderSelectionContext';

function PharmacistOrders() {
  const { key } = usePortalPartnerBrand();

  return (
    <PharmacistOrdersProvider>
      <OrderSelectionProvider>
        <PharmacistOrdersModalsProvider>
          <AdminPageLayout title="Orders" themeVariant={key} testId="pharmacist-orders">
            <ManagedErrorToasts />
            <PharmacistOrderTables />
            <ApprovalDocumentsModal />
            <UnableToDispenseModal />
            <ConfirmDispenseModal />
            <SplitOrderModal />
            <MarkAsCollectedModal />
          </AdminPageLayout>
        </PharmacistOrdersModalsProvider>
      </OrderSelectionProvider>
    </PharmacistOrdersProvider>
  );
}

export default PharmacistOrders;
